import "./Mainpage.css"
import Navbar from "../../components/Navbar/Navbar";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import React, { useEffect, useState } from "react";
import axios from "axios";
import {Link} from "react-router-dom";

// Simple in-memory cache to avoid re-downloading posts on navigation
let cachedArticles = null;
let cachedAt = 0;
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

export default function Mainpage({ setShowSplash }) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [minSplashDone, setMinSplashDone] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [showSplashOnce, setShowSplashOnce] = useState(() => {
    // Csak akkor mutassuk a splash-t, ha még nem látta a user
    return !sessionStorage.getItem('mainpage_splash_shown');
  });
  const apiUrl = process.env.REACT_APP_API_URL;
  const storageUrl = process.env.REACT_APP_STORAGE_URL;

  useEffect(() => {
    document.title = "Kútonline - Kezdőlap";
    if (!showSplashOnce) {
      setMinSplashDone(true);
      return;
    }
    const el = document.querySelector('.footer-telex');
    if (el){
      const prev = el.style.display;
     el.style.display = 'none';
    }
    // Splash legalább 3mp-ig
    const timer = setTimeout(() => {
      setMinSplashDone(true);
      sessionStorage.setItem('mainpage_splash_shown', '1');


    const el = document.querySelector('.footer-telex');
    if (el){
      const prev = el.style.display;
     el.style.display = 'block';
    }
    
   
    }, 3000);
    return () => clearTimeout(timer);
  }, []);



  // Fetch articles with caching (sessionStorage + in-memory), so we don't re-download on navigation.

const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  
  let videoId = '';
  
  try {
      // 1. If it's a standard link (youtube.com/watch?v=ID)
      if (url.includes('watch?v=')) {
          videoId = new URLSearchParams(new URL(url).search).get('v');
      } 
      // 2. If it's a shortened mobile link (youtu.be/ID)
      else if (url.includes('youtu.be/')) {
          videoId = url.split('youtu.be/')[1].split('?')[0];
      } 
      // 3. If someone pasted an embed link already (youtube.com/embed/ID)
      else if (url.includes('embed/')) {
          videoId = url.split('embed/')[1].split('?')[0];
      }

      // If we successfully found an ID, rebuild the URL and FORCE your parameters onto it
      if (videoId) {
          return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&controls=0&playlist=${videoId}`;
      }
  } catch (error) {
      console.error("Could not parse YouTube URL", error);
  }

  return null;
};

useEffect(() => {

    fetch(`${apiUrl}/video-config`)
        .then((res) => {
            if (!res.ok) throw new Error("Network response was not ok");
            return res.json();
        })
        .then((data) => {

            const rawUrl = data.youtube_url;
            const finalUrl = getYouTubeEmbedUrl(rawUrl);
            
            setVideoUrl(finalUrl);
        })
        .catch((error) => console.error("Error fetching video link:", error));
}, [apiUrl]);

  useEffect(() => {
    let cancelled = false;
    const now = Date.now();

    setLoading(true);

    // Try sessionStorage first
    try {
      const stored = sessionStorage.getItem("mainpage_articles");
      const storedTs = Number(sessionStorage.getItem("mainpage_articles_ts") || 0);
      if (stored && now - storedTs < CACHE_TTL_MS) {
        const parsed = JSON.parse(stored);
        setArticles(parsed || []);
        setLoading(false);
        return () => { cancelled = true; };
      }
    } catch (e) {
      // ignore JSON errors
    }

    // Fallback to in-memory cache
    if (cachedArticles && now - cachedAt < CACHE_TTL_MS) {
      setArticles(cachedArticles);
      setLoading(false);
      return () => { cancelled = true; };
    }

    // Otherwise fetch
    axios.get(`${apiUrl}/mainpage_new`)
      .then(res => {
        if (cancelled) return;
        const data = Array.isArray(res.data) ? res.data : [];
        setArticles(data);
        setLoading(false);
        cachedArticles = data;
        cachedAt = Date.now();
        try {
          sessionStorage.setItem("mainpage_articles", JSON.stringify(data));
          sessionStorage.setItem("mainpage_articles_ts", String(Date.now()));
        } catch (e) {
          // storage may be full/blocked, ignore
        }
      })
      .catch(() => {
        if (!cancelled) setArticles([]);
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, [apiUrl]);

  const showSplash = showSplashOnce && (!minSplashDone || loading);
  return (
    <div>
      {showSplash ? (
        <div className="mainpage-splash-wrapper">
          
          <div className="mainpage-splash-bg" />
          
          <div className="mainpage-logo-overlay">            
            {/* Csak a háttérkép látszik, minden más tartalom rejtve marad */}
            <img
              src="/images/logo.webp"
              alt="Kút Online logó"
              fetchPriority="high"
              style={{
                width: '100vw',
                height: '100vh',
                objectFit: 'contain',
                margin: 0,
                display: 'block',
                maxWidth: '100vw',
                maxHeight: '100vh',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 2
              }}
            />
          </div>       
        </div>
        
      ) : (
        <>
          <DarkModeButton />
          <Navbar />
          <div className="page-container">
            <section className="mainpage-intro">          
              <div className="mainpage-intro-text">
                <h2>Üdvözlünk a Kút Online oldalán!</h2>
                <p>A Kút Online egy fiatalok által létrehozott online újság, amely a magyar népi kultúrával foglalkozó sokszínű világot mutatja be. Célunk, hogy népszerűsítsük a művészeti értékeket és közérthető ismeretterjesztő tartalmakat készítsünk. Olyan nevet szerettünk volna, amely kapcsolatot teremt a múlttal. Így jutottunk el a „kút” képéhez, ami nem csak a múlttal való kapcsolódást szimbolizálja, hanem a közösséget is "friss vízzel" látja el.</p>
              </div>
              <div className="mainpage-intro-image">
                {articles && articles.length > 0 && (
                  <>
                    <Link to={`/article/${articles[0].slug}`} className="featured-link">
                      <img src={`${storageUrl}${articles[0].thumbnail}`} alt={articles[0].title || "Bemutatkozó kép"} />
                      <span className="latest-badge" tabIndex={0} aria-label="Legfrissebb cikk">ÚJ</span>
                    </Link>
                    <Link to={`/article/${articles[0].slug}`} className="mainpage-featured-title">{articles[0].title}</Link>
                  </>
                )}
              </div>
            </section>
            <section className="mainpage-latest-articles">
              <h2>Új a Kút Online-on:</h2>
              <div className="mainpage-articles">
                {articles.slice(1, 5).map(article => (
                  <Link key={article.id} to={`/article/${article.slug}`}>
                      <img src={`${storageUrl}${article.thumbnail}` || "/images/article.jpg"} alt={article.title || "Cikk"} />
                      <p>{article.title}</p>
                  </Link>
                ))}
              </div>
            </section>
            <section className="mainpage-video-section">
              <div className="mainpage-video-container">
                <iframe
                  className="mainpage-video-iframe"
                  src={videoUrl}
                  title="Hajtű"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                ></iframe>
              </div>
            </section>
          </div>
          <ScrollToTopButton />
        </>
      )}
    </div>
  );
}